import React from 'react';
import GenericList from 'src/shared/genericList';
import { useTranslation } from 'react-i18next';

export default function MapLayerList() {
  const { t } = useTranslation();
  const columns = [
    { field: 'map_layer_id', headerName: 'ID', hide: true },
    {
      field: 'map_layer_name',
      headerName: t('NAME'),
      width: '150',
      flex: 1,
      editable: true,
    },
  ];

  return <GenericList objectName={'map-layers'} columns={columns} rowId={'map_layer_id'} />;
}
